import { render, staticRenderFns } from "./ConfigLinks.vue?vue&type=template&id=ba3bc928&scoped=true"
import script from "./ConfigLinks.vue?vue&type=script&lang=js"
export * from "./ConfigLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3bc928",
  null
  
)

export default component.exports